module.exports = __webpack_public_path__ + "static/audio.113e1b58.svg";